import { Component, Input } from '@angular/core';
import { TechnicalService } from 'src/app/interfaces';
/**
 * Technical Service item
 *
 * @export
 * @class StaItemComponent
 */
@Component({
  selector: 'app-sta-item',
  templateUrl: './sta-item.component.html',
  styleUrls: ['./sta-item.component.scss'],
})
export class StaItemComponent {
  /**
   * Technical service to render
   *
   * @type {TechnicalService}
   * @memberof StaItemComponent
   */
  @Input() technicalService: TechnicalService;
}
